export {
  default as tennisBalls,
  ReactComponent as TennisBalls,
} from '@assets/icons/features-and-amenities/tennis-balls.svg'    
